import GlobalBase from '../global-base';

/**
 * The JS controller for the visibility toggler block.
 */
class VisibilityToggler extends GlobalBase {

    cache() {
        this.togglerGroups = document.querySelectorAll( '.visibility-toggler' );
        this.initialCss = document.querySelectorAll( '.visibility-toggler-css' );
    }

    docReady() {
        this.cache();
        this.init();
    }

    init() {
        if ( ! this.togglerGroups ) {
            // Nothing to do.
            return null;
        }

        this.togglerGroups.forEach( group => {
            const togglers = group.querySelectorAll( '.visibility-toggler-button' );

            if ( togglers ) {
                // Find all control classes for this group.
                const allClasses = _.uniq( _.flatMap( togglers, toggler => _.get( toggler, 'dataset.controls', '' ) ) );

                // Hide all first.
                _.map( allClasses, this.hideByClass );

                // Handle all togglers in this group.
                togglers.forEach( ( toggler, index ) => {
                    // Show the first.
                    if ( index === 0 ) {
                        this.showByClass( _.get( toggler, 'dataset.controls', '' ) );
                    }

                    toggler.addEventListener( 'click', ( event ) => {
                        // Remove active state from all.
                        _.map( togglers, this.removeActiveClass );
                        // Set this as active.
                        event.target.classList.add( 'is-active' );
                        // Hide all first.
                        _.map( allClasses, this.hideByClass );
                        // Show the selected.
                        this.showByClass( event.target.dataset.controls );
                    } )
                } )
            }

            // Remove all of the initial css.
            if ( this.initialCss ) {
                this.initialCss.forEach( element => {
                    element.remove();
                } )
            }
        } );
    }

    removeActiveClass( element ) {
        element.classList.remove( 'is-active' );
    }

    showByClass( cssClass ) {
        const togglable = document.querySelectorAll( `.${ cssClass }` );
        if ( togglable ) {
            togglable.forEach( t => {
                t.classList.remove( 'is-hidden' );
                t.classList.add( 'is-block' );
            } )
        }
    }

    hideByClass( cssClass ) {
        const togglable = document.querySelectorAll( `.${ cssClass }` );
        if ( togglable ) {
            togglable.forEach( t => {
                t.classList.remove( 'is-block' );
                t.classList.add( 'is-hidden' );
            } )
        }
    }
}

// Export the singleton.
export default new VisibilityToggler();
